export const promotionBadgeBaseClassName =
  'inline-flex h-[1.625rem] w-fit shrink-0 items-center whitespace-nowrap rounded-full border px-2.5 font-outfit text-base font-medium leading-none backdrop-blur-[2px]'
